export const getBaseUrl = () =>
  `${location.origin.replace(/\/$/, '')}${import.meta.env.BASE_URL.replace(/\/$/, '')}`;
